import * as React from 'react';

import { cn, Col, Separator } from '@rematter/ui-web';

import { useAuditLogLocation } from '../../_state/auditLogModule.state';
import { MenuItemGroup } from '../../_types';
import { useTranslations } from '../../i18n/useTranslations';
import { AuditLogLink, AuditLogPath } from '../../routes';

export type MenuGroupProps = { group: MenuItemGroup; index: number };

export const MenuGroup = ({ group, index }: MenuGroupProps) => {
  const t = useTranslations();
  const [location] = useAuditLogLocation();

  const visibleItems = React.useMemo(
    () =>
      group.items
        .filter(({ hideFromMenu }) => !hideFromMenu)
        .map((item) => {
          const patterns = Array.isArray(item.pattern)
            ? item.pattern
            : [item.pattern];
          const isActive = patterns.some((p) => p.startsWith(location));
          const firstPattern = patterns[0];
          return { ...item, isActive, href: firstPattern as AuditLogPath };
        }),
    [group.items, location],
  );

  const groupTitle = group.groupTitleKey
    ? t.routes.groups[group.groupTitleKey]
    : undefined;

  return (
    <Col className="@MenuGroup" gap2>
      {groupTitle && (
        <div className={'text-xs font-medium text-current/50'}>
          {groupTitle}
        </div>
      )}
      {!groupTitle && index > 0 && (
        <Separator className={'mt-0.5 mb-1.5 opacity-15'} />
      )}
      <Col className={'gap-[2px]'}>
        {visibleItems.map(
          ({ labelKey, icon: Icon, href, isActive, disabled }) => (
            <AuditLogLink
              key={labelKey}
              href={href}
              className={cn(
                'flex cursor-pointer items-center gap-1.5 rounded-sm p-2 text-sm font-medium hover:bg-current/8',
                isActive && 'bg-foreground! text-space',
                disabled && 'line-through opacity-40',
              )}
            >
              {Icon && <Icon size={16} className={'opacity-50'} />}{' '}
              {t.routes.modules[labelKey]}
            </AuditLogLink>
          ),
        )}
      </Col>
    </Col>
  );
};
